import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import AdminNav from './AdminNav';
import AdminSideNav from './AdminSideNav';

const AdminLayout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div style={{ display: 'flex', minHeight: '100vh', background: '#f0fdf4' }}>
            <AdminSideNav isOpen={sidebarOpen} collapsed={sidebarCollapsed} onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)} />
            {!isMobile && sidebarOpen && (
                <div style={{
                    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.3)', zIndex: 998
                }} onClick={() => setSidebarOpen(false)} />
            )}
            <div style={{
                flex: 1,
                marginLeft: isMobile ? 0 : (sidebarCollapsed ? 70 : 250),
                minHeight: '100vh', display: 'flex', flexDirection: 'column',
                transition: 'margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                minWidth: 0, overflow: 'hidden',
            }}>
                <AdminNav onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
                <main style={{ flex: 1, padding: isMobile ? '16px 12px' : '24px 28px', paddingBottom: isMobile ? 80 : 24 }}>
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default AdminLayout;
